import SchoolActions from "./SchoolActions";

const SchoolRow = ({ school }) => {
  const isActive = school.is_active;

  return (
    <tr>
      <td>
        <span className="text-md fw-medium text-primary-light">
          {school.nombre}
        </span>
      </td>
      <td>
        <span className="text-sm d-block text-secondary-light">
          {school.siglas}
        </span>
      </td>
      <td>
        <span className="text-sm d-block text-secondary-light">
          {school.tipo}
        </span>
      </td>
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            school.publica
              ? "bg-info-focus text-info-main"
              : "bg-warning-focus text-warning-main"
          }`}
        >
          {school.publica ? "Pública" : "Privada"}
        </span>
      </td>
      <td>
        <span
          className={`px-3 py-1 rounded-pill fw-medium text-sm ${
            isActive
              ? "bg-success-focus text-success-main"
              : "bg-danger-focus text-danger-main"
          }`}
        >
          {isActive ? "Activo" : "Inactivo"}
        </span>
      </td>
      <td>
        <span className="text-center text-neutral-700 text-xl">
          <SchoolActions school={school} />
        </span>
      </td>
    </tr>
  );
};

export default SchoolRow;
